import { w_desktop, w_desktopMax, w_tablet } from 'elem/utils/devices';
import css from './index.module.scss';
export interface PictureType extends React.ImgHTMLAttributes<HTMLImageElement> {
    srcMax?: string;
    srcDesktop?: string | undefined;
    srcPad?: string | undefined;
    srcMobile?: string | undefined;
}

export default function EFPicture(props: PictureType) {
    const { src, srcMax = '', srcDesktop = '', srcPad = '', srcMobile = '', alt, className, ...rest } = props;
    // const src_h = handleDynamicPath(String(src));
    // const srcMax_h = handleDynamicPath(String(srcMax));
    // const srcDesktop_h = handleDynamicPath(String(srcDesktop));
    // const srcPad_h = handleDynamicPath(String(srcPad));
    // const srcMobile_h = handleDynamicPath(String(srcMobile));

    return (
        <div className={`${css.efPicture} ef-picture${className ? ` ${className}` : ''}`}>
            <picture className="picture">
                {srcMobile && <source media={`(max-width: ${w_tablet - 1}px)`} srcSet={srcMobile} />}
                {srcPad && <source media={`(max-width: ${w_desktop}px)`} srcSet={srcPad} />}
                {srcDesktop && <source media={`(max-width: ${w_desktopMax - 1}px)`} srcSet={srcDesktop} />}
                {srcMax && <source media={`(min-width: 1921px)`} srcSet={srcMax} />}
                <img className="picture-img" src={src} alt={alt || 'EF-Image'} aria-label={alt || 'EF-Image'} {...rest} />
            </picture>
        </div>
    );
}
